import { extractFileNameFromDisposition } from '../../services/tasks/taskDocumentsService.js';

const IMAGE_EXTENSIONS = new Set(['PNG', 'JPG', 'JPEG', 'WEBP', 'GIF', 'BMP', 'SVG']);
const TEXT_EXTENSIONS = new Set(['TXT', 'MD', 'CSV', 'JSON', 'XML', 'HTML', 'LOG']);
const SHEET_EXTENSIONS = new Set(['XLSX', 'XLS', 'ODS']);

const getExtensionFromName = (name) => {
  const fileName = String(name || '').trim();
  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex <= 0 || lastDotIndex === fileName.length - 1) {
    return '';
  }

  return fileName.slice(lastDotIndex + 1).toUpperCase();
};

// Los entries del explorador no traen `extension` (solo name/mimeType), los
// documentos de tarea sí (normalizeTaskDocument): se deriva del nombre si falta.
export const resolvePreviewType = ({ name, extension, mimeType } = {}) => {
  const normalizedMimeType = String(mimeType || '').toLowerCase();
  const normalizedExtension = String(extension || getExtensionFromName(name)).toUpperCase();

  if (normalizedMimeType.startsWith('image/') || IMAGE_EXTENSIONS.has(normalizedExtension)) {
    return 'image';
  }

  if (normalizedMimeType.includes('pdf') || normalizedExtension === 'PDF') {
    return 'pdf';
  }

  // docx-preview solo entiende OOXML: .doc (binario viejo) queda como no soportado.
  if (normalizedMimeType.includes('wordprocessingml') || normalizedExtension === 'DOCX') {
    return 'docx';
  }

  if (
    normalizedMimeType.includes('spreadsheetml')
    || normalizedMimeType.includes('ms-excel')
    || normalizedMimeType.includes('opendocument.spreadsheet')
    || SHEET_EXTENSIONS.has(normalizedExtension)
  ) {
    return 'sheet';
  }

  if (normalizedMimeType.startsWith('text/') || TEXT_EXTENSIONS.has(normalizedExtension)) {
    return 'text';
  }

  return 'unsupported';
};

export const getStorageFileProxyUrl = (fileId) => `/api/storage/files/${fileId}/proxy`;

export const getTaskDocumentDownloadUrl = (taskId, documentId, { inline = false } = {}) => {
  const url = `/api/tasks/${taskId}/documents/${documentId}/download`;
  return inline ? `${url}?inline=1` : url;
};

// folderId del explorador es opaco: "task:<taskId>" o "field:<taskId>:<campo>".
export const getTaskIdFromFolderId = (folderId) => {
  const match = String(folderId || '').match(/^(?:task|field):([^:]+)/);
  return match?.[1] || null;
};

export const openPdfInNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const downloadFromUrl = async (url, fallbackName) => {
  const response = await fetch(url, { method: 'GET' });

  if (!response.ok) {
    throw new Error(`No se pudo descargar el archivo. Codigo: ${response.status}`);
  }

  const blob = await response.blob();
  const fileName = extractFileNameFromDisposition(response.headers.get('content-disposition'))
    || fallbackName
    || 'archivo';
  const objectUrl = window.URL.createObjectURL(blob);
  const link = window.document.createElement('a');

  link.href = objectUrl;
  link.download = fileName;
  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};
